import React from 'react';
import { Marker } from 'react-map-gl/mapbox';

const LocationMarker = ({ location, position, onClick }) => {
  if (!position) return null;

  return (
    <Marker
      longitude={position.longitude}
      latitude={position.latitude}
      anchor="bottom"
      onClick={e => {
        // Prevent default event propagation
        e.originalEvent.stopPropagation();
        onClick(location);
      }}
    >
      <div 
        style={{ 
          cursor: 'pointer'
        }}
        title={location}
      >
        <svg 
          height="40" 
          viewBox="0 0 24 24" 
          style={{ 
            fill: '#d00',
            stroke: '#fff',
            strokeWidth: '1px',
            filter: 'drop-shadow(0 2px 2px rgba(0,0,0,0.3))'
          }}
        >
          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
        </svg>
      </div>
    </Marker>
  );
};

export default LocationMarker;
